import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import { CreateElement } from 'vue/types/umd';
import { i18n } from '@/localization';
import '@/registerServiceWorker';
import '@/layouts/index';
import '@/assets/svg/index';
import '@/assets/styles/index.scss';

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);

// @ts-ignore
import VueMoment from 'vue-moment';
Vue.use(VueMoment);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: (h: CreateElement) => h(App),
    mounted() {
        // @ts-ignore
        this.init();
        const self = this;
        // @ts-ignore
        window.addEventListener('resize', () => self.init());
        // @ts-ignore
        window.addEventListener('orientationchange', () => self.init());
    },
    methods: {
        init() {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        },
    },
}).$mount('#app');
